import { defineStore } from 'pinia';

export const useHelpersStore = defineStore('helpers', {
  state: () => ({
    lastFetch: null,
  }),

  actions: {},
});
